import React, { useEffect } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {
  handleSendGlobal,
  ranking,
  riskLevelHighColor,
  riskLevelLowColor,
  riskLevelMediumColor,
  riskLevelVeryHighColor,
  riskLevelVeryLowColor,
  settingsColor,
} from "../../helpers";
import bin from "../../images/bin-grey.png";
import {
  updateRiskTemplate,
  updateProbability,
  updateConsequence,
  updatePostProbability,
  updatePostConsequence,
  deleteRiskTemplate,
} from "../../store/entities/global";

export default function EditTemplateRow(props) {
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.entities.global.data);
  const { template, selectedRiskType } = props;
  const {
    riskId,
    category,
    height,
    riskDescription,
    riskPreProbability,
    riskPreConsequence,
    riskMitigation,
    riskPostProbability,
    riskPostConsequence,
  } = template;

  function handleDelete() {
    dispatch(deleteRiskTemplate({ riskId }));
  }

  function handleChange(e) {
    const { name, value } = e.target;
    dispatch(updateRiskTemplate({ riskId, key: name, value }));
  }

  function getMaxHeight() {
    try {
      const descHeight = document.getElementById(`${riskId}-des`).scrollHeight;
      const mitiHeight = document.getElementById(`${riskId}-mit`).scrollHeight;
      const minHeight = Math.max(descHeight, mitiHeight) + 2;
      dispatch(updateRiskTemplate({ riskId, key: "height", value: minHeight }));
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    getMaxHeight();
  }, [selectedRiskType]);

  return (
    <Container>
      <textarea
        id={riskId + "-des"}
        type="text"
        onChange={handleChange}
        onBlur={handleSendGlobal}
        className="field textarea"
        name="riskDescription"
        value={riskDescription}
        style={{ height: height }}
        // maxLength={maxLength}
      />
      <button
        onClick={() => dispatch(updateProbability({ riskId }))}
        className={`toggle field ${ranking[riskPreProbability]}`}
        onBlur={handleSendGlobal}
      >
        {ranking[riskPreProbability]}
      </button>
      <button
        onClick={() => dispatch(updateConsequence({ riskId }))}
        className={`toggle field ${ranking[riskPreConsequence]}`}
        onBlur={handleSendGlobal}
      >
        {ranking[riskPreConsequence]}
      </button>
      <textarea
        id={riskId + "-mit"}
        type="text"
        onChange={handleChange}
        onBlur={handleSendGlobal}
        className="field textarea miti"
        name="riskMitigation"
        value={riskMitigation}
        style={{ height: height }}
        // maxLength={maxLength}
      />
      <button
        onClick={() => dispatch(updatePostProbability({ riskId }))}
        className={`toggle field ${ranking[riskPostProbability]}`}
        onBlur={handleSendGlobal}
      >
        {ranking[riskPostProbability]}
      </button>
      <button
        onClick={() => dispatch(updatePostConsequence({ riskId }))}
        className={`toggle field ${ranking[riskPostConsequence]}`}
        onBlur={handleSendGlobal}
      >
        {ranking[riskPostConsequence]}
      </button>
      <select
        name="category"
        id="riskId"
        className="field cat end"
        value={category}
        onBlur={handleSendGlobal}
        onChange={handleChange}
      >
        {categories.map((category, index) => {
          return (
            <option key={index} value={category}>
              {category}
            </option>
          );
        })}
      </select>
      <div className="bin hidden">
        <img src={bin} alt="bin" onClick={handleDelete} />
      </div>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  scroll-snap-align: start;
  display: flex;
  margin: 3px 30px;
  &:hover .hidden {
    opacity: 1;
  }
  .field {
    margin-right: 4px;
    padding: 8px 4px;
    border: 1px solid #e1e1e1;
    border-radius: 5px;
    display: flex;
    justify-content: flex-start;
    font-size: 14px;
  }
  .cat {
    text-align: center;
    width: 40px;
    :focus {
      border: 1px solid ${settingsColor};
    }
  }
  .end {
    margin-right: 0;
  }
  .textarea {
    flex-basis: 0;
    flex-grow: 1;
    resize: none;
    &:focus {
      border: 1px solid ${settingsColor};
    }
  }
  .miti {
    flex-grow: 2;
  }
  .toggle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 55px;
    font-size: 12px;
  }
  .bin {
    margin: auto;
    position: absolute;
    right: -24px;
    top: 0px;
    bottom: 0px;
    max-width: 20px;
    max-height: 20px;
    transition: opacity 0.3s;
    cursor: pointer;
  }
  .addIcon {
    margin: -5px 30px 15px 30px;
    max-width: 25px;
    max-height: 25px;
    padding: 0;
    border: none;
  }
  .hidden {
    opacity: 0;
  }
  .selected {
    background-color: ${settingsColor};
    color: white;
    font-weight: bold;
  }
  p {
    background-color: white;
    border-radius: 5px;
  }
  .Very.High {
    background-color: ${riskLevelVeryHighColor};
    color: white;
  }
  .High {
    background-color: ${riskLevelHighColor};
    color: white;
  }
  .Medium {
    background-color: ${riskLevelMediumColor};
  }
  .Low {
    background-color: ${riskLevelLowColor};
  }
  .Very.Low {
    background-color: ${riskLevelVeryLowColor};

  }
  .buttonRow {
    display: flex;
    align-items: center;
    border: 1px solid red;
  }
`;
